import { Link } from 'react-router-dom'

const IconInstagram = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <circle cx="12" cy="12" r="4"/>
    <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" stroke="none"/>
  </svg>
)
const IconPinterest = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
  </svg>
)
const IconX = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.729-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
)
const IconFacebook = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
)

const LINKS = {
  Shop: [
    { label: 'New In', to: '/new-in' },
    { label: 'Women', to: '/women' },
    { label: 'Men', to: '/men' },
    { label: 'Beauty', to: '/beauty' },
    { label: 'Homeware', to: '/homeware' },
    { label: 'Sale', to: '/sale' },
  ],
  Brands: [
    { label: 'John Lewis', to: '/brands/john-lewis' },
    { label: 'Marks & Spencer', to: '/brands/marks-and-spencer' },
    { label: 'Harrods', to: '/brands/harrods' },
    { label: 'Fenwick', to: '/brands/fenwick' },
    { label: 'All Brands', to: '/brands' },
  ],
  Company: [
    { label: 'About Maravelle', to: '/about' },
    { label: 'How It Works', to: '/how-it-works' },
    { label: 'Editorial', to: '/editorial' },
    { label: 'Contact', to: '/contact' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '/legal/privacy' },
    { label: 'Cookie Policy', to: '/legal/cookies' },
    { label: 'Terms of Use', to: '/legal/terms' },
    { label: 'Affiliate Disclosure', to: '/legal/affiliate-disclosure' },
  ],
}

export function Footer() {
  return (
    <footer className="bg-[#06090c]">
      <div className="w-full px-6 sm:px-10 md:px-16 lg:px-24 xl:px-32 py-20 md:py-28">

        {/* Brand centrepiece */}
        <div className="text-center pb-12 mb-12 border-b border-white/5">
          <Link
            to="/"
            className="font-display text-5xl md:text-6xl font-light tracking-[0.25em] text-[#f0ebe0] hover:text-[#d4952a] transition-colors"
          >
            MARAVELLE
          </Link>
          <p className="mt-4 text-xs text-[#6b7280] font-body tracking-[0.2em] uppercase">
            Curated luxury fashion, beauty &amp; homeware from Britain's finest heritage brands
          </p>
          {/* Social icons */}
          <div className="flex items-center justify-center gap-5 mt-5">
            <a href="https://instagram.com/maravelle" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
              className="text-[#6b7280] hover:text-[#d4952a] transition-colors">
              <IconInstagram />
            </a>
            <a href="https://pinterest.com/maravelle" target="_blank" rel="noopener noreferrer" aria-label="Pinterest"
              className="text-[#6b7280] hover:text-[#d4952a] transition-colors">
              <IconPinterest />
            </a>
            <a href="https://x.com/maravelle" target="_blank" rel="noopener noreferrer" aria-label="X"
              className="text-[#6b7280] hover:text-[#d4952a] transition-colors">
              <IconX />
            </a>
            <a href="https://facebook.com/maravelle" target="_blank" rel="noopener noreferrer" aria-label="Facebook"
              className="text-[#6b7280] hover:text-[#d4952a] transition-colors">
              <IconFacebook />
            </a>
          </div>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {Object.entries(LINKS).map(([heading, items]) => (
            <div key={heading}>
              <h4 className="text-xs font-medium tracking-widest uppercase text-[#d4952a] mb-4 font-body">
                {heading}
              </h4>
              <ul className="flex flex-col gap-2">
                {items.map(({ label, to }) => (
                  <li key={to}>
                    <Link
                      to={to}
                      className="text-sm text-[#9ca3af] hover:text-[#f0ebe0] transition-colors font-body"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#6b7280] font-body">
            &copy; {new Date().getFullYear()} Maravelle Ltd. All rights reserved.
          </p>
          <p className="text-xs text-[#6b7280] font-body text-center max-w-md">
            Maravelle is an affiliate storefront. We earn a commission when you purchase via our
            links at no extra cost to you.{' '}
            <Link to="/legal/affiliate-disclosure" className="text-[#d4952a] hover:underline">
              Learn more
            </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}
